import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useCadaverService } from 'hooks/useCadaverService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useExameNecrodontoscopicoService } from 'hooks/useExameNecrodontoscopico'

export const CAMPOS_FORM = [
  'corPele',
  'corIris',
  'tipoCabelo',
  'corCabelo',
  'quantidadeCabelo',
  'sobrancelha',
  'conjuntiva',
  'palpebras',
  'arcoSenil',
  'larguraNariz',
  'pontaNariz',
  'dorsoNariz',
  'pupilas',
  'labios',
  'boca',
  'formatoRosto',
  'barba',
  'bigode',
  'lobuloOrelhaEsquerda',
  'lobuloOrelhaDireita',
  'rigidezBucoFacial',
  'carbonizado',
  'emDecomposicao',
  'cianoseFacial',
  'denticao',
  'protusao',
  'tratamentoProtetico',
  'tratamentoOrtodontico',
]

export const valoresIniciais = {
  corPele: 0.5,
  corPeleChecked: false,
  corIris: 0.5,
  corIrisChecked: false,
  tipoCabelo: 0.33,
  tipoCabeloChecked: false,
  corCabelo: '#3C2814',
  corCabeloChecked: false,
  quantidadeCabelo: 0.33,
  quantidadeCabeloChecked: false,
  sobrancelha: 0.5,
  sobrancelhaChecked: false,
  conjuntiva: 'BRILHANTE',
  conjuntivaChecked: false,
  palpebras: 'FECHADAS',
  palpebrasChecked: false,
  arcoSenil: 'AUSENTE',
  arcoSenilChecked: false,
  larguraNariz: 0.5,
  larguraNarizChecked: false,
  pontaNariz: 0.5,
  pontaNarizChecked: false,
  dorsoNariz: 0.5,
  dorsoNarizChecked: false,
  pupilas: null,
  pupilasChecked: false,
  labios: 0.5,
  labiosChecked: false,
  boca: 0.5,
  bocaChecked: false,
  formatoRosto: 0.51,
  formatoRostoChecked: false,
  barba: null,
  barbaChecked: false,
  bigode: null,
  bigodeChecked: false,
  lobuloOrelhaEsquerda: null,
  lobuloOrelhaEsquerdaChecked: false,
  lobuloOrelhaDireita: null,
  lobuloOrelhaDireitaChecked: false,
  rigidezBucoFacial: null,
  rigidezBucoFacialChecked: false,
  carbonizado: null,
  carbonizadoChecked: false,
  emDecomposicao: null,
  emDecomposicaoChecked: false,
  cianoseFacial: null,
  cianoseFacialChecked: false,
  denticao: null,
  denticaoChecked: false,
  protusao: null,
  protusaoChecked: false,
  tratamentoProtetico: null,
  tratamentoProteticoChecked: false,
  tratamentoOrtodontico: null,
  tratamentoOrtodonticoChecked: false,
}

export const valoresDentesIniciais = [
  { identificador: '18', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '17', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '16', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '15', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '14', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '13', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '12', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '11', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '21', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '22', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '23', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '24', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '25', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '26', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '27', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '28', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '48', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '47', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '46', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '45', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '44', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '43', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '42', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '41', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '31', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '32', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '33', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '34', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '35', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '36', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '37', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '38', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '55', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '54', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '53', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '52', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '51', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '61', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '62', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '63', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '64', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '65', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '85', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '84', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '83', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '82', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '81', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },

  { identificador: '71', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '72', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '73', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '74', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
  { identificador: '75', ausente: false, faceDistal: false, faceVestibular: false, faceMesial: false, faceLingual: false, observacoes: null },
]

export const useExameNecrodontoscopico = () => {
  const params = useParams()
  const router = useRouter()
  const cadaverService = useCadaverService()
  const exameRealizadoService = useExameRealizadoService()
  const exameNecrodontoscopicoService = useExameNecrodontoscopicoService()

  const [exameNecrodontoscopico, setExameNecrodontoscopico] = useState(null)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [processandoDados, setProcessandoDados] = useState(false)
  const [formData, setFormData] = useState(valoresIniciais)
  const [formMarcas, setFormMarcas] = useState([])
  const [formSVG, setFormSVG] = useState({})
  const [formDentes, setFormDentes] = useState(valoresDentesIniciais)
  const [activeStep, setActiveStep] = useState(0)
  const [editarDentes, setEditarDentes] = useState(false)

  // Fetch initial form data on mount
  const fetchExameNecrodontoscopico = useCallback(async () => {
    try {
      const response = await exameNecrodontoscopicoService.listarExameNecrodontoscopicoDadosFormulario(params.id)
      if (!response) {
        await exameRealizadoService.atualizarTemplateExame(params.id)
        router.history.push(`/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${params.id}`)
        return
      }

      setFormData(
        CAMPOS_FORM.reduce((acumulador, campo) => {
          acumulador[campo] = response[campo] ?? valoresIniciais[campo]
          acumulador[`${campo}Checked`] = response[campo] !== null && response[campo] !== undefined
          return acumulador
        }, {})
      )

      setExameNecrodontoscopico(response)
    } catch (error) {
      console.error('Failed to fetch necrodontoscopic exam data', error)
    }
  }, [params.id, router.history])

  useEffect(() => {
    fetchExameNecrodontoscopico()
  }, [fetchExameNecrodontoscopico])

  const handleChange = useCallback((prop, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [prop]: value,
    }))
  }, [])

  const handleChangeComArredondamento = useCallback((prop, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [prop]: value > 0.9 ? 1 : value,
    }))
  }, [])

  // Wizard step navigation and data submission
  const handleNext = async () => {
    try {
      if (activeStep === 0) {
        setProcessandoOperacao(true)
        const dados = Object.fromEntries(
          Object.keys(formData)
            .filter((prop) => !prop.endsWith('Checked') && !prop.endsWith('ColorPicker'))
            .map((prop) => [prop, formData[`${prop}Checked`] ? formData[prop] : null])
        )
        await exameNecrodontoscopicoService.editarExameNecrodontoscopico(exameNecrodontoscopico.id, dados)
        setProcessandoOperacao(false)
        setActiveStep((prev) => prev + 1)
      }

      if (activeStep === 1) {
        setProcessandoOperacao(true)
        const cadaverId = exameNecrodontoscopico?.exReal?.exSol?.cadavs?.[0]?.id
        if (cadaverId) {
          await cadaverService.setarCicatrizesCadaver(cadaverId, exameNecrodontoscopico.exReal.id, formMarcas)
        }
        await exameNecrodontoscopicoService.setarSVGSExameNecrodonto(exameNecrodontoscopico.id, formSVG)
        setProcessandoOperacao(false)
        setActiveStep((prev) => prev + 1)
      }

      if (activeStep === 2) {
        setProcessandoOperacao(true)
        if (editarDentes) {
          await exameNecrodontoscopicoService.editarDentes(formDentes)
        } else {
          await exameNecrodontoscopicoService.cadastrarDentes(exameNecrodontoscopico.id, formDentes)
        }
        const htmlMapaOdonto = document.getElementById('mapaOdonto')
        await exameNecrodontoscopicoService.setarImagemMapaOdonto(exameNecrodontoscopico.id, htmlMapaOdonto)
        await exameRealizadoService.construirDocumentoExameRealizado(exameNecrodontoscopico.id)
        setProcessandoOperacao(false)
        setActiveStep((prev) => prev + 1)
      }
    } catch (error) {
      setProcessandoOperacao(false)
      console.error('Error saving necrodontoscopic stage data', error)
    }
  }

  const handleBack = useCallback(() => {
    setActiveStep((prev) => prev - 1)
  }, [])

  return {
    exameNecrodontoscopico,
    processandoOperacao,
    processandoDados,
    formData,
    formMarcas,
    formSVG,
    formDentes,
    activeStep,
    editarDentes,
    setFormMarcas,
    setFormSVG,
    setFormDentes,
    setProcessandoDados,
    setEditarDentes,
    handleChange,
    handleChangeComArredondamento,
    handleNext,
    handleBack,
  }
}
